// extracted by mini-css-extract-plugin
module.exports = {"upload-wrapper":"upload-wrapper___1Hnsj","icon-upload-icon":"icon-upload-icon___CAUDS"};